import { AnimatePresence, motion } from 'motion/react'
import { useConnectionStore } from '@/store/connection'

/** Subtle top banner that only shows when the connection isn't healthy. */
export function ConnectionBanner() {
  const phase = useConnectionStore((s) => s.phase)
  const show = phase === 'reconnecting' || phase === 'auth-error' || phase === 'connecting'
  const label =
    phase === 'auth-error'
      ? 'Pålogging utløpt — kobler til på nytt…'
      : phase === 'connecting'
        ? 'Kobler til Home Assistant…'
        : 'Mistet forbindelsen — prøver igjen…'

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ y: -40, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -40, opacity: 0 }}
          className="pointer-events-none fixed inset-x-0 top-0 z-[60] flex justify-center p-3"
        >
          <div className="flex items-center gap-2 rounded-full border border-[var(--color-hairline)] bg-[var(--color-surface-2)]/90 px-4 py-2 text-sm text-[var(--color-text-dim)] backdrop-blur">
            <span className="h-2 w-2 animate-pulse rounded-full bg-[var(--color-warn)]" />
            {label}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}
